import { useAgenticLogicDatasets } from "@src/api/agentic-logic/list-agentic-logic-datasets";
import { useIsAdmin } from "@src/api/user-auths/is-admin";

import {
  type AgenticLogicDataSurfaceState,
  deriveAgenticLogicDataSurface,
} from "./dataSurface";

/**
 * The acting user's org-data surface: read the admin status, and only for an
 * admin the org's dataset keys (the list route refuses members).
 */
export const useAgenticLogicDataSurface = (): AgenticLogicDataSurfaceState => {
  const isAdmin = useIsAdmin();
  const datasetsQuery = useAgenticLogicDatasets(
    {},
    { enabled: isAdmin === true }
  );
  return deriveAgenticLogicDataSurface({
    isAdmin,
    datasets: {
      isFetched: datasetsQuery.isFetched,
      isError: datasetsQuery.isError,
      keys: (datasetsQuery.data?.datasets ?? []).map((dataset) => dataset.key),
    },
  });
};
